export const categoryTableId = "table-category";
export const groupTableId = "table-group";
export const serviceTableId = "table-service";
export const tabTableId = "table-tab";
export const userTableId = "table-user";
